import db from "../Db";

import { GetApiData } from "../Get/ApiData";
import { handleError } from "../Function";

var _ = require("lodash");

export async function CreateAccessibilite(headers) {
  const _accessibilite = await GetApiData("ACCESSIBILITE", headers);

  if (_accessibilite.Message !== undefined) {
    return _accessibilite;
  }

  var drops = [];
  _.forEach(_accessibilite, (accessibilite) => {
    drops.push({
      IDACCESSIBILITE: accessibilite.IDACCESSIBILITE,
      LIBELLE: accessibilite.LIBELLE.trim(),
      BL_ARCHIVE: accessibilite.BL_ARCHIVE,
      ORDRE: accessibilite.ORDRE,
    });
  });

  return await db
    .open()
    .then(() => {
      return db.ACCESSIBILITE.bulkAdd(drops)
        .then(() => {
          return "";
        })
        .catch((err) => {
          return handleError(err);
        });
    })
    .catch((err) => {
      return handleError(err);
    });
}
